module.exports = __webpack_public_path__ + "media/images/sp/page_common/keywords/keyword_sakura-dc69ec0af20a0543434c40ae10bb124a.jpg";